<template>
    <div>
        <table width="100%" class="vs-table vs-table--tbody-table ">
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    Warehouse Code
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.warehouse.code + ' - ' + this.form.warehouse.name }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Shipment Number
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.shipment_number }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    Supplier
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.supplier_code + ' - ' + this.form.supplier_name }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Delivery Note Number
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.delivery_order_number }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    Purchase Data
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.code }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Delivery Note Date
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + formatDate(this.form.dn_date) }}
                </td>
            </tr>
            <tr>
                <td class="td vs-table--td" style="padding: 5px">
                    Receive Date
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + formatDate(this.form.date) }}
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    Notes
                </td>
                <td class="td vs-table--td" style="padding: 5px">
                    {{ ': ' + this.form.notes }}
                </td>
            </tr>
        </table>

        <table width="100%" class="vs-table vs-table--tbody-table print">
            <thead class="vs-table--thead">
                <tr>
                    <th colspan="5">
                        <div>Purchase Order Data</div>
                    </th>
                    <th colspan="5">
                        <div>Receive data</div>
                    </th>
                </tr>
                <tr>
                    <th>
                        <div>Supplier</div>
                        <div>SKU Code</div>
                    </th>
                    <th>
                        <div>Internal</div>
                        <div>SKU Code</div>
                    </th>
                    <th>
                        <div>Internal</div>
                        <div>SKU Description</div>
                    </th>
                    <th>HU</th>
                    <th>Qty</th>
                    <th>HU</th>
                    <th>Qty</th>
                    <th>Batch</th>
                    <th>Expired Date</th>
                    <th>Check Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in form.lines_dto" :key="index" style="padding-bottom: 5px">
                    <td class="td vs-table--td" :rowspan="item.check_count"
                        v-if="index == 0 || form.lines_dto[index].purchase_order_line_id != form.lines_dto[index - 1].purchase_order_line_id"
                        style="padding: 5px">
                        {{ item.item_unit.sku_code_supplier }}
                    </td>
                    <td class="td vs-table--td" :rowspan="item.check_count"
                        v-if="index == 0 || form.lines_dto[index].purchase_order_line_id != form.lines_dto[index - 1].purchase_order_line_id"
                        style="padding: 5px">
                        {{ item.item_unit.sku_code }}
                    </td>
                    <td class="td vs-table--td" :rowspan="item.check_count"
                        v-if="index == 0 || form.lines_dto[index].purchase_order_line_id != form.lines_dto[index - 1].purchase_order_line_id"
                        style="padding: 5px">
                        {{ item.item_unit.item_name }}
                    </td>
                    <td class="td vs-table--td" :rowspan="item.check_count"
                        v-if="index == 0 || form.lines_dto[index].purchase_order_line_id != form.lines_dto[index - 1].purchase_order_line_id"
                        style="padding: 5px">
                        {{ item.po_item_unit.name }}
                    </td>
                    <td class="td vs-table--td" :rowspan="item.check_count"
                        v-if="index == 0 || form.lines_dto[index].purchase_order_line_id != form.lines_dto[index - 1].purchase_order_line_id"
                        style="padding: 5px">
                        {{ item.po_quantity }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.item_unit.name }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.quantity }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.batch }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.expired_date }}
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                        {{ item.check_status.name }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="flex justify-center w-full pt-6 print-button">
            <vs-button style="margin:'0 auto'" color="primary" @click="handlePrint()">Print</vs-button>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    components: {
    },
    mounted() {
        this.id = this.$route.params.id;
        this.mode = this.$route.params.mode;
        this.initData();
    },
    data() {
        return {
            dialog: {
                save: false,
            },
            id: null,
            checkOptions: [{
                value: 0,
                name: "Passed",
            }, {
                value: 1,
                name: "Damaged",
            }],
            attachment: null,
            form: {
                lines_dto: [],
            },
        }
    },
    methods: {
        async handlePrint() {
            await window.print();
        },
        initData() {
            this.$http
                .get(`${this.$store.state.inbound.purchaseOrder.baseUrlPath}/receive/${this.id}`)
                .then((resp) => {
                    if (resp.code == 200) {
                        this.form = resp.data;
                        this.form.lines_dto.forEach((item) => {
                            item.check_count = 0
                            item.check_status = this.checkOptions[item.is_damaged]
                            this.form.lines_dto.forEach((v) => {
                                if (item.purchase_order_line_id == v.purchase_order_line_id) {
                                    item.check_count++
                                }
                            })
                        })
                    }
                });
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('DD MMM YYYY');
            };
        },
        formatLocalNumber: () => {
            return (val) => {
                return Number(val).toLocaleString("id-ID");
            };
        },
    },
}
</script>
<style>
/* Set the page size to A4 and the orientation to landscape */
@page {
    size: A4 landscape;
}

/* Set the font size to 12px for printing */
@media print {
    body {
        font-size: 12px;
        background: none !important;
    }

    * {
        background: none !important;
    }

    header,
    footer,
    .print-button,
    #content-area * :not(.content-wrapper *) {
        display: none !important;
        visibility: hidden !important;
    }

    .router-view,
    .router-content {
        padding: 0 !important;
        margin: 0 !important;
    }
}

table.print {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
    margin-top: 20px;
}

table.print td,
table.print th {
    border: 1px solid #abab !important;
    text-align: left;
    padding: 8px;
}
</style>
